import { MyLog } from "@common/common";
import { forEach, isJsObject } from "@util/utils";

/*
interface Navigator {
  getUserMedia?: any;
  webkitGetUserMedia?: any;
  mozGetUserMedia?: any;
  msGetUserMedia?: any;
  mediaDevices?:any;
}
*/

export interface GetMediaStreamOptions {
  video: any;
  image: boolean;
  audio?: boolean;
  selector?: string;
}

export interface MediaStreamWrapper {
  type: string;
  stream: MediaStream | null | undefined;
  hasMediaDevices?: boolean;
  stop(): void;
}

const gmfNames = ['webkit', 'moz', 'ms'];
function isf(f: any) {
  return typeof f === 'function';
}

function gmf(nav: any): any {
  if (nav) {
    if (isf(nav.getUserMedia)) {
      return nav.getUserMedia;
    }
    for (var i = 0; i < gmfNames.length; i++) {
      var n = gmfNames[i] + 'GetUserMedia';
      if (isf(nav[n])) {
        return nav[n];
      }
    }
  }
}

interface GetUserMediaObjectResult {
  success: boolean;
  hasMediaDevices?: boolean;
  getStream?: (options: any) => Promise<MediaStream>;
  f?: any;
  o?: any;
}
function getUserMediaObject(): GetUserMediaObjectResult {
  const ms = (navigator as Navigator).mediaDevices;
  const msf = gmf(ms);
  let o: any = navigator, f = gmf(navigator as Navigator);
  //console.log('UMO:', navigator, ms, msf, f);
  if (msf) {
    o = ms;
    f = msf;
  }
  if (isf(f)) {
    //f.call(o, options, successCallback, failureCallback);
    return {
      success: true,
      getStream: (function (obj, func) {
        return function (opts: GetMediaStreamOptions) {
          return func.call(obj, opts);
        };
      }(o, f)),
      f: f,
      o: o,
      hasMediaDevices: !!msf,
    } as GetUserMediaObjectResult;
  }
  return {
    success: false,
  };
}

function stopStream(stream: MediaStream) {
  MyLog.log('STOP:Stream:', stream);
  if (stream && isf(stream.getTracks)) {
    forEach(stream.getTracks(), (value: MediaStreamTrack) => {
      isf(value.stop) && value.stop();
      value.enabled = false;
    });
  }
}

export function getStream(
  options: GetMediaStreamOptions,
  successCallback: (data: MediaStreamWrapper) => void,
  errorCallback: (err: any) => void
) {
  const obj = getUserMediaObject();

  const constraints: any = {
    video: options.video,
    facingMode: "environment"
  };

  if (options.audio) {
    constraints.audio = true;
  }

  if (obj.success) {
    obj.getStream!(constraints).then(function (stream: MediaStream) {
      successCallback({
        type: 'video',
        stream: stream,
        hasMediaDevices: obj.hasMediaDevices,
        stop: function () {
          stopStream(this.stream as MediaStream);
        }
      });
    }).catch(function (err: any) {
      errorCallback({
        noStream: true,
        error: err
      });
    });
    return;
  }

  errorCallback({
    noApi: true
  });
}



export const enum MediaCaptureTypes {
  IMAGE = 'image',
  VIDEO = 'video'
};


interface FindBestFitResult {
  widthIn: number;
  heightIn: number;
  width: number;
  height: number;
  scale?: number;
  scaleW?: number;
  scaleH?: number;
}
export function findBestFit(
  imageWidthIn: number,
  imageHeightIn: number,
  scale: any,
  onlyBoundingBox = false
): FindBestFitResult {

  const result: FindBestFitResult = {
    widthIn: imageHeightIn,
    heightIn: imageHeightIn,
    width: imageWidthIn,
    height: imageHeightIn
  };

  if (isJsObject(scale) && scale.width && scale.height) {
    let scaleMax = Math.max(scale.width, scale.height),
      scaleMin = Math.min(scale.width, scale.height),

      inMax = Math.max(imageWidthIn, imageHeightIn),
      inMin = Math.min(imageWidthIn, imageHeightIn);

    if (inMax > scaleMax || inMin > scaleMin) {
      result.width = scaleMax;
      result.height = scaleMin;

      if (imageWidthIn < imageHeightIn) {
        result.width = scaleMin;
        result.height = scaleMax;
      }

      if (onlyBoundingBox) {
        return result;
      }

      if (imageWidthIn > result.width || imageHeightIn > result.height) {
        const scaleWidth = result.width / imageWidthIn;
        const scaleHeight = result.height / imageHeightIn;

        if (scaleWidth < scaleHeight) {
          result.height = scaleWidth * imageHeightIn;
        } else {
          result.width = scaleHeight * imageWidthIn;
        }
        const scale = Math.min(scaleHeight, scaleWidth);
        result.scale = scale;
        result.scaleW = scaleWidth;
        result.scaleH = scaleHeight;
      }
    }
  }
  return result;
}
